import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forbidden',
  imports: [],
  templateUrl: './forbidden.component.html',
  styleUrl: './forbidden.component.scss'
})
export class ForbiddenComponent implements OnInit {

  public targetOpeningTime: string = '稍後';
  public customerServicePhone: string = '02-412-8006';

  ngOnInit(): void {
    
  }
}
